import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import { loginUserRequest, oktaTokenRequestAction } from '../../store/login';
import styles from './Login.module.css';

interface PropsFromDispatch {
  readonly loginUserRequest: typeof loginUserRequest;
  readonly oktaTokenRequest: typeof oktaTokenRequestAction;
}

interface PropsFromState {
  readonly errorMessage: string;
  readonly showLoader: boolean;
  readonly accessToken: string;
}

interface State {
  readonly username: string;
  readonly password: string;
  readonly offlineText: string;
  readonly wasSilent: boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class LoginOKTA extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      username: '',
      password: '',
      offlineText: '',
      wasSilent: false
    };
  }

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const returnedState = params.get('state');
    
    // Store whether this was a silent attempt so componentDidUpdate knows
    const wasSilent = sessionStorage.getItem('pkce_silent') === 'true';
    sessionStorage.removeItem('pkce_silent');
    this.setState({ wasSilent });

    if (!code) {
      window.location.replace('/login#oktaSilentFailed');
      return;
    }

    // Validate state to prevent CSRF attacks
    const savedState = sessionStorage.getItem('pkce_state');
    sessionStorage.removeItem('pkce_state');

    if (!savedState || returnedState !== savedState) {
      console.error('State mismatch — possible CSRF attack, aborting login');
      // window.location.replace('/login#oktaSilentFailed');
      window.location.replace(wasSilent ? '/login#oktaSilentFailed' : '/login');
      return;
    }

    const codeVerifier = sessionStorage.getItem('pkce_code_verifier');
    const nonce = sessionStorage.getItem('pkce_nonce');
    sessionStorage.removeItem('pkce_code_verifier');
    sessionStorage.removeItem('pkce_nonce');

    if (!codeVerifier || !nonce) {
      console.error('No code verifier or nonce found in sessionStorage');
      // window.location.replace('/login#oktaSilentFailed');
      window.location.replace(wasSilent ? '/login#oktaSilentFailed' : '/login');
      return;
    }

    // Just dispatch and walk away — componentDidUpdate will react to the result
    this.props.oktaTokenRequest(code, codeVerifier || '', nonce || '');
  }

  componentDidUpdate(prevProps: AllProps): void {
    const { errorMessage } = this.props;

    // Saga reported a failure
    if (errorMessage && errorMessage !== prevProps.errorMessage) {
      // Only bounce to #oktaSilentFailed if this was a silent attempt
      window.location.replace(
      this.state.wasSilent ? '/login#oktaSilentFailed' : '/login'
    );
    }
  }

  userLogin = () => {
    this.props.loginUserRequest(this.state.username, this.state.password);
  }

  public render() {
    const strings = getI18n();

    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}>
              <a href='http://www.zamia.be' target='_blank' rel="noreferrer"><img alt="" className={styles.logo} src={require('../../assets/images/login.png')} /></a>
            </div>
          </div>
          <div id='loader' className={styles.loadingContainer}>
            <div className={styles.logo}>
              <img alt="" src={require('../../assets/images/spinnerLoaderBlue.gif')} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ login }: ApplicationState): PropsFromState => ({
  errorMessage: login.errorMessage,
  showLoader: login.showLoader,
  accessToken: login.accessToken
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loginUserRequest: (username: string, password: string) => dispatch(loginUserRequest(username, password)),
  oktaTokenRequest: (code: string, codeVerifier: string, nonce: string) => dispatch(oktaTokenRequestAction(code, codeVerifier, nonce))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginOKTA);
